import Vue from 'vue';
import Vuex from 'vuex';

import api from '@/api';
import { USER_ROLES } from '@/config';

Vue.use(Vuex);

function initialState() {
  return {
    auth: JSON.parse(localStorage.getItem('auth_details')) || null,
    projects: {},
    currentProject: {},
    currentSubsection: {},
    currentSid: {},
    currentDid: {},
    positionTimeData: {},
    positionTimeDataCache: {},
    positionTimeDataCacheWatch: 0,
    // Ideally we could combine projectVideos and projectVideosLoaded and
    // have a `loaded` flag or something like that, but `vue.watch` doesn't
    // seem to be able to watch changes in JS Objects.
    projectVideos: [],
    projectVideosLoaded: [],
    // NOTE: In projectLayers, we are storing the actual subsection_data
    // whereas in projectVideos, we are only storing the did. We should
    // refactor to store the subsection_data in projectVideos as well.
    projectLayers: [], // TODO: We need this for videos because of slow position time data
    projectDsms: [],
    projectImages: [], // but do we need this for layers and images?
    // projectSidsLoaded: [], // -> Project Data Loaded? al async? browser 6 to same url block?
    projectDids: {},
    globalPosData: {
      lat: 0,
      lng: 0,
      setter: '',
    },
    commentsData: {},
    commentsDataCache: {},
    commentCategories: {},
    // Will Add Comments
    commentDataWatch: 0,

    // Map Layer
    isLayerOrtVisible: true,
    isLayerDsmVisible: false,
    isLayerDrwVisible: false,
    // Map Filter
    isCommentsVisible: true,
    isImagesVisible: true,
    isVideosVisible: true,
    isAllProjectDataVisible: false,
    // Map Features
    showCommentOnMapTool: true,
    isCommentOnMapEnabled: false,
    mapCoords: {},

    // To be cleaned
    // TODO: Most components are changing the current sid through router
    // Figure out best way to do this. Is it router or is it through store
    Did: '',
    // NOTE: This only works for single video. If multiple videos are present,
    // this logic will need more work
    isVideoPlayerVisible: '',

    layerDetails: [],

    mapObject: {},
  };
}

export default new Vuex.Store({
  state: initialState,


  getters: {
    loggedIn(state) {
      return state.auth.token != null;
    },
    // eslint-disable-next-line
    getProject: (state)=>(pid)=>{
      return Array.from(state.projects).find(project => (project.project_id === pid));
    },
    // eslint-disable-next-line
    // getSubsection:(state)=>(sid)=>{
    //   for (let i = 0; i < state.projects.length; i++) {
    //     // eslint-disable-next-line
    //     Array.from(state.projects[i].subsections).find((subsection) => {
    //       console.log('SID', subsection.subsection_id);
    //       return subsection.subsection_id === sid;
    //     });
    //   }
    // },
  },


  /* eslint-disable no-param-reassign */
  mutations: {
    setAuthDetails(state, authDetails) {
      state.auth = authDetails;
    },
    destroyAuthDetails(state) {
      state.auth = null;
    },
    setProjects(state, projects) {
      state.projects = projects;
    },
    setGlobalPosData(state, posData) {
      state.globalPosData = posData;
    },
    setPositionTimeData(state, posTimeData) {
      state.positionTimeData = posTimeData;
    },
    addPositionTimeDataToCache(state, payload) {
      state.positionTimeDataCache[payload.data_id] = payload.data;
      state.positionTimeDataCacheWatch++;
      const did = Number(payload.data_id);
      // FIXME: May require polyfill on older browsers
      if (!state.projectVideosLoaded.includes(did)) {
        state.projectVideosLoaded.push(did);
      }
    },
    addCommentsDataToCache(state, payload) {
      state.commentsDataCache[payload.data_id] = payload.data;
      state.commentDataWatch++;
    },
    clearProjectData(state) {
      state.commentsDataCache = {};
      state.currentProject = {};
      state.projectVideos = [];
      state.projectImages = [];
      state.projectLayers = [];
      state.projectDsms = [];
      state.projectDids = {};
      state.layerDetails = [];
      state.currentSid = {};
      state.currentDid = {};
    },
    setProjectDids(state, projectDids) {
      state.projectDids = projectDids;
    },
    addToProjectVideos(state, did) {
      state.projectVideos.push(did);
    },
    clearProjectVideosLoaded(state) {
      state.projectVideosLoaded = [];
    },
    addToProjectLayers(state, data) {
      state.projectLayers.push(data);
    },
    addToProjectDsms(state, data) {
      state.projectDsms.push(data);
    },
    addToProjectImages(state, data) {
      state.projectImages.push(data);
    },
    setCommentsData(state, commentsData) {
      state.commentsData = commentsData;
    },
    setCurrentProject(state, currentProject) {
      state.currentProject = currentProject;
    },
    setCurrentSubsection(state, currentSubsection) {
      state.currentSubsection = currentSubsection;
    },
    setCurrentDid(state, did) {
      state.currentDid = did;
    },
    setCurrentSid(state, sid) {
      state.currentSid = sid;
    },
    setCommentCategories(state, commentCategories) {
      state.commentCategories = commentCategories;
    },
    setVideoPlayerVisibility(state, isVideoPlayerVisible) {
      state.isVideoPlayerVisible = isVideoPlayerVisible;
    },
    toggleOrtVisibility(state, bool) {
      state.isLayerOrtVisible = bool;
    },
    toggleDsmVisibility(state, bool) {
      state.isLayerDsmVisible = bool;
    },
    toggleDrwVisibility(state, bool) {
      state.isLayerDrwVisible = bool;
    },
    toggleCommentsVisibility(state, bool) {
      state.isCommentsVisible = bool;
    },
    toggleAllProjectVisibility(state, bool) {
      state.isAllProjectDataVisible = bool;
    },
    toggleCommentOnMapTool(state, bool) {
      state.showCommentOnMapTool = bool;
    },
    toggleCommentOnMap(state, bool) {
      state.isCommentOnMapEnabled = bool;
    },
    toggleImagesVisiblilty(state, bool) {
      state.isImagesVisible = bool;
    },
    toggleVideosVisibility(state, bool) {
      state.isVideosVisible = bool;
    },
    setMapCoords(state, coords) {
      state.mapCoords = coords;
    },
    resetAll(state) {
      // acquire initial state
      const s = initialState();
      Object.keys(s).forEach((key) => {
        // console.log('clearing store', state[key]);
        state[key] = s[key];
      });
    },
    addToLayerDetails(state, data) {
      state.layerDetails.push(data);
    },
    toggleLayerVisibility(state, layerId) {
      state.layerDetails.forEach((layer) => {
        if (layer.id === layerId) {
          if (layer.isVisible) {
            // layer.layerObject.setOpacity(0);
            state.mapObject.removeLayer(layer.layerObject);
            layer.isVisible = false;
            layer.vectorLayers.forEach((vector) => {
              state.mapObject.removeLayer(vector.vectorObject);
              // vector.vectorObject.setStyle({ opacity: 0 });
              vector.isVisible = false;
            });
          } else {
            // layer.layerObject.setOpacity(1);
            state.mapObject.addLayer(layer.layerObject);
            layer.isVisible = true;
            layer.vectorLayers.forEach((vector) => {
              state.mapObject.addLayer(vector.vectorObject);
              // vector.vectorObject.setStyle({ opacity: 1 });
              vector.isVisible = true;
            });
          }
        }
      });
    },
    toggleVectorVisibility(state, data) {
      state.layerDetails.forEach((layer) => {
        if (layer.id === data.layerId) {
          layer.vectorLayers.forEach((vector) => {
            if (vector.id === data.vectorId) {
              if (vector.isVisible) {
                state.mapObject.removeLayer(vector.vectorObject);
                // vector.vectorObject.setStyle({ opacity: 0 });

                vector.isVisible = false;
              } else {
                state.mapObject.addLayer(vector.vectorObject);                
                // vector.vectorObject.setStyle({ opacity: 1 });
                vector.isVisible = true;
              }
            }
          });
        }
      });
    },
    setMapObject(state, mapObject) {
      state.mapObject = mapObject;
    },
  /* eslint-enable no-param-reassign */
  },


  actions: {
    retrieveAuthDetails({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        api.userLogin(credentials)
          .then((response) => {
            if (response.status === 200) {
              const authDetails = {};
              authDetails.role = USER_ROLES.USER;
              authDetails.token = response.data.token;
              authDetails.user_id = response.data.user_id;
              const isAdmin = response.data.is_admin;
              const isStaff = response.data.is_staff;

              if (authDetails.token && isAdmin) {
                authDetails.role = USER_ROLES.ADMIN;
              } else if (authDetails.token && isStaff) {
                authDetails.role = USER_ROLES.STAFF;
              }

              // Store data in local storage
              localStorage.setItem('auth_details', JSON.stringify(authDetails));
              commit('setAuthDetails', authDetails);
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // TODO: Update Action Name
    // eslint-disable-next-line
    destroyAuthDetails(context) {
      return new Promise((resolve, reject) => {
        api.userLogout()
          .then((response) => {
            if (response.status === 200) {
              localStorage.removeItem('auth_details');
              context.commit('resetAll');
              context.commit('destroyAuthDetails');
              resolve(response);
            }
          })
          .catch((error) => {
            localStorage.removeItem('auth_details');
            context.commit('resetAll');
            context.commit('destroyAuthDetails');
            reject(error);
          });
      });
    },

    /* eslint-disable no-param-reassign */
    retrieveProjects(context, payload = {}) {
      if (context.getters.loggedIn) {
        if (context.state.projects.length > 0) {
          if (payload.pid) {
            const project = Array.from(context.state.projects).find(project => (project.project_id === Number(payload.pid)));
            context.commit('setCurrentProject', project);
            if (payload.sid) {
              Array.from(project.subsections).forEach((subsection) => {
                if (subsection.subsection_id === parseInt(payload.sid, 10)) {
                  context.commit('setCurrentSubsection', subsection);
                }
              });
            }
          }
        } else {
          api.projectDetails()
            .then((response) => {
              const projectsList = response.data;
              Array.from(projectsList).forEach((project) => {
                project.subsectionPointer = '';
                project.stacked = true;
              });
              context.commit('setProjects', projectsList);
              if (payload.pid) {
                const project = Array.from(context.state.projects).find(project => (project.project_id === Number(payload.pid)));
                context.commit('setCurrentProject', project);
                if (payload.sid) {
                  Array.from(project.subsections).forEach((subsection) => {
                    if (subsection.subsection_id === parseInt(payload.sid, 10)) {
                      context.commit('setCurrentSubsection', subsection);
                    }
                  });
                }
              }
            }, (error) => {
              // TODO: Remove Direct Error Logging throughout the project
              // console.log(error);
            });
        }
      }
    },
    /* eslint-enable no-param-reassign */

    /* eslint-enable no-param-reassign */
    retrievePositionJSON(context, payload) {
      if (!payload.data_id) { return; }
      if (!context.state.currentProject) { console.log('no proj', payload); return; }
      if (context.getters.loggedIn) {
        if (context.state.positionTimeDataCache[payload.data_id]) {
          if (payload.setToCurrent) {
            context.commit('setPositionTimeData', context.state.positionTimeDataCache[payload.data_id]);
          }
        } else {
          let url = null;
          Array.from(context.state.currentProject.subsections).forEach((sub) => {
            Array.from(sub.data).forEach((data) => {
              if (Number(data.data_id) == Number(payload.data_id)) {
                url = data.pos;
              }
            });
          });
          api.downloadJSON(url)
            .then((response) => {
              if (response.status === 200) {
                context.commit('addPositionTimeDataToCache', { data_id: payload.data_id, data: response.data });
                if (payload.setToCurrent) {
                  context.commit('setPositionTimeData', response.data);
                }
              }
            })
            .catch((error) => {
              // Remove error logging and handle error.
              console.log(error);
            });
        }
      }
    },

    retrieveComments(context, did) {
      if (context.getters.loggedIn) {
        api.getSubsectionComments(did)
          .then((response) => {
            if (response.status === 200) {
              context.commit('addCommentsDataToCache', { data_id: did, data: response.data });
            }
          })
          .catch((error) => {
            // Remove error logging and handle error.
            console.log(error);
          });
      }
    },

    // retrieveComments(context, did) {
    //   if (context.getters.loggedIn) {
    //     api.getSubsectionComments(did)
    //       .then((response) => {
    //         if (response.status === 200) {
    //           context.commit('setCommentsData', response.data);
    //         }
    //       });
    //   }
    // },

    playNextVideo(context, did) {
      if (!context.state.currentProject.subsections) { return; }
      if (!did) { console.log('playNextVideo was called without did'); return; }
      const dids = context.state.projectVideos;
      const currentIndex = dids.indexOf(Number(did));
      if (currentIndex + 1 < dids.length) {
        context.commit('setCurrentDid', dids[currentIndex + 1]);
      }
    },

    playPreviousVideo(context, did) {
      if (!context.state.currentProject.subsections) { return; }
      if (!did) { console.log('playNextVideo was called without did'); return; }
      const dids = context.state.projectVideos;
      const currentIndex = dids.indexOf(Number(did));
      if (currentIndex - 1 > 0) {
        context.commit('setCurrentDid', dids[currentIndex - 1]);
      }
    },
    retrieveCommentCategories(context) {
      if (context.getters.loggedIn) {
        api.getCommentCategories()
          .then((response) => {
            if (response.status === 200) {
              context.commit('setCommentCategories', response.data);
            }
          });
      }
    },

  },
});
